/**
 * Bulk Cargo Request.
 *
 * Bulk Containers (with items or ad-hoc from manifest.
 *
 */

var VRC = VRC || {};
VRC.BulkCargoRequest = (function (data) {
	var _bulkTypeId;
	var _bulkTypeName;
	var _cargoItemId;
	var _companyId;
	var _companyName;
	var _containerId;
	var _deliveryType;
	var _destinationId;
	var _destinationName;
	var _dgClass;
	var _dgUnNumber;
	var _itemDescription;
	var _itemId;
	var _portColourCode;
	var _originId;
	var _originName;
	var _sg;
	var _valueQty;
	var _valueUnit;
	var _displayPort;
	var _manifestAction;
	var _itemGroupName;
	var _itemGroupId;
	var _tankShape;
	var _hidden;

	var init = function (data) {
		parse(data);
	};

	var getTankShape = function () {
		return _tankShape;
	};

	var setTankShape = function () {
		var valueUnit = getValueUnit();
		_tankShape = valueUnit === 'mt' ? 'circle' : 'square';

	};

	var getCargoItemId = function () {
		return _cargoItemId;
	};

	var setCargoItemId = function (cargoItemId) {
		cargoItemId = VRC.Utils.Number.parseInt(cargoItemId);
		_cargoItemId = cargoItemId;
	};

	var getDeliveryType = function () {
		return _deliveryType;
	};

	var setDeliveryType = function (deliveryType) {
		_deliveryType = deliveryType;
	};

	var getItemDescription = function () {
		return _itemDescription;
	};

	var setItemDescription = function (itemDescription) {
		_itemDescription = itemDescription;
	};

	var getPortColourCode = function () {
		return _portColourCode;
	};

	var setPortColourCode = function (portColourCode) {
		if (!portColourCode) {
			portColourCode = VRC.MasterDataService.getColour(getDestinationId(), getOriginId());
		}
		_portColourCode = portColourCode;
	};

	var getOriginId = function () {
		return _originId;
	};

	var setOriginId = function (originId) {
		originId = VRC.Utils.Number.parseInt(originId);
		_originId = originId;
	};

	var getOriginName = function () {
		return _originName;
	};

	var setOriginName = function (originName) {
		if (!originName) {
			var origin = VRC.MasterDataService.getPort(getOriginId());
			if (origin) {
				originName = origin.name;
			}
		}
		_originName = originName;
	};

	var getValueQty = function () {
		return _valueQty;
	};

	var setValueQty = function (valueQty) {
		valueQty = VRC.Utils.Number.parseFloat(valueQty);

		_valueQty = valueQty;
	};

	var getValueUnit = function () {
		return _valueUnit;
	};

	var setValueUnit = function (valueUnit) {
		_valueUnit = valueUnit;
	};

	var getDestinationId = function () {
		return _destinationId;
	};

	var setDestinationId = function (destinationId) {
		destinationId = VRC.Utils.Number.parseInt(destinationId);
		_destinationId = destinationId;
	};

	var getDestinationName = function () {
		return _destinationName;
	};

	var setDestinationName = function (destinationName) {
		if (!destinationName) {
			var destination = VRC.MasterDataService.getPort(getDestinationId())
			if (destination) {
				destinationName = destination.name;
			}
		}
		_destinationName = destinationName;
	};

	var getDgClass = function () {
		return _dgClass;
	};

	var setDgClass = function (dgClass) {
		_dgClass = dgClass;
	};

	var getSg = function () {
		return _sg;
	};

	var setSg = function (sg) {
		sg = VRC.Utils.Number.parseFloat(sg);
		_sg = sg;
	};

	var getCompanyId = function () {
		return _companyId;
	};

	var setCompanyId = function (companyId) {
		companyId = VRC.Utils.Number.parseFloat(companyId);
		_companyId = companyId;
	};

	var getCompanyName = function () {
		return _companyName;
	};

	var setCompanyName = function (companyName) {
		if (!companyName) {
			var company = VRC.MasterDataService.getCompany(getCompanyId())
			if (company) {
				companyName = company.name;
			}
		}
		_companyName = companyName;
	};

	var getBulkTypeName = function () {
		return _bulkTypeName;
	};

	var setBulkTypeName = function (bulkTypeName) {
		if (!bulkTypeName) {
			var bulkType = VRC.MasterDataService.getBulkType(getBulkTypeId());
			if (bulkType) {
				bulkTypeName = bulkType.name;
			}
		}
		_bulkTypeName = bulkTypeName;
	};

	var getBulkTypeId = function () {
		return _bulkTypeId;
	};

	var setBulkTypeId = function (bulkTypeId) {
		bulkTypeId = VRC.Utils.Number.parseInt(bulkTypeId);
		_bulkTypeId = bulkTypeId;
	};

	var getItemGroupName = function () {
		return _itemGroupName;
	};

	var setItemGroupName = function (itemGroupName) {
		_itemGroupName = itemGroupName;
	};

	var subtractValueQty = function (qty) {
		qty = VRC.Utils.Number.parseFloat(qty);
		if (qty === undefined || isNaN(qty)) {
			qty = 0;
		}
		var currentQty = getValueQty();
		var newQty = currentQty - qty;
		if (isNaN(newQty)) {
			newQty = 0;
		}
		setValueQty(newQty);
	};

	var getContainerId = function () {

		return _containerId;
	};

	var setContainerId = function (containerId) {
		containerId = VRC.Utils.Number.parseFloat(containerId);
		_containerId = containerId;
	};

	var getDgUnNumber = function () {
		return _dgUnNumber;
	};

	var setDgUnNumber = function (dgUnNumber) {
		_dgUnNumber = dgUnNumber;
	};

	var getItemId = function () {
		return _itemId;
	};

	var setItemId = function (itemId) {
		_itemId = itemId;
	};

	var getDisplayPort = function () {
		return _displayPort;
	};

	var setDisplayPort = function (displayPort) {
		if (!displayPort) {
			displayPort = VRC.MasterDataService.getDisplayPort(getDestinationId(), getOriginId());
		}
		_displayPort = displayPort;
	};

	var getManifestAction = function () {
		return _manifestAction;
	};

	var setManifestAction = function (manifestAction) {
		_manifestAction = manifestAction;
	};

	var getItemGroupId = function () {
		return _itemGroupId;
	};

	var setItemGroupId = function (itemGroupId) {
		_itemGroupId = itemGroupId;
	};

	var isHidden = function () {
		return _hidden || false;
	};

	var setHidden = function (hidden) {
		_hidden = hidden;
	};

	var parse = function (data) {
		setBulkTypeId(data.bulkTypeId);
		setBulkTypeName(data.bulkTypeName);
		setCargoItemId(data.cargoItemId);
		setCompanyId(data.companyId);
		setCompanyName(data.companyName);
		setContainerId(data.containerId);
		setDeliveryType(data.deliveryType);
		setDestinationId(data.destinationId);
		setDestinationName(data.destinationName);
		setDgClass(data.dgClass);
		setDgUnNumber(data.dgUnNumber);
		setItemDescription(data.itemDescription);
		setItemGroupName(data.itemGroupName);
		setItemGroupId(data.itemGroupId);
		setItemId(data.itemId);
		setOriginId(data.originId);
		setOriginName(data.originName);
		setSg(data.sg);
		setValueQty(data.valueQty);
		setValueUnit(data.valueUnit);
		setManifestAction(data.manifestAction);

		//Dependent on originId and destinationId to be set.
		setPortColourCode(data.portColorCode);
		setDisplayPort(data.displayPort);
		setTankShape();
	};

	var toJson = function () {
		return {
			bulkTypeId: getBulkTypeId(),
			bulkTypeName: getBulkTypeName(),
			cargoItemId: getCargoItemId(),
			companyId: getCompanyId(),
			companyName: getCompanyName(),
			containerId: getContainerId(),
			deliveryType: getDeliveryType(),
			dgClass: getDgClass(),
			dgUnNumber: getDgUnNumber(),
			itemDescription: getItemDescription(),
			itemGroupName: getItemGroupName(),
			itemId: getItemId(),
			portColorCode: getPortColourCode(),
			originId: getOriginId(),
			originName: getOriginName(),
			destinationId: getDestinationId(),
			destinationName: getDestinationName(),
			valueQty: getValueQty(),
			valueUnit: getValueUnit(),
			sg: getSg(),
			displayPort: getDisplayPort(),
			manifestAction: getManifestAction(),
			tankShape: getTankShape(),
			isHidden: isHidden()
		}
	};

	init(data);

	return {
		getCargoItemId: getCargoItemId,
		setCargoItemId: setCargoItemId,
		getDeliveryType: getDeliveryType,
		setDeliveryType: setDeliveryType,
		getItemDescription: getItemDescription,
		setItemDescription: setItemDescription,
		getItemGroupName: getItemGroupName,
		getDisplayPort: getDisplayPort,
		getPortColourCode: getPortColourCode,
		setPortColourCode: setPortColourCode,
		getOriginId: getOriginId,
		setOriginId: setOriginId,
		getOriginName: getOriginName,
		setOriginName: setOriginName,
		getValueQty: getValueQty,
		setValueQty: setValueQty,
		getValueUnit: getValueUnit,
		setValueUnit: setValueUnit,
		getDangerous: getDgClass,
		setDangerous: setDgClass,
		getDestinationId: getDestinationId,
		setDestinationId: setDestinationId,
		getDestinationName: getDestinationName,
		setDestinationName: setDestinationName,
		getCompanyId: getCompanyId,
		setCompanyId: setCompanyId,
		getCompanyName: getCompanyName,
		setCompanyName: setCompanyName,
		getBulkTypeId: getBulkTypeId,
		setBulkTypeId: setBulkTypeId,
		getBulkTypeName: getBulkTypeName,
		setBulkTypeName: setBulkTypeName,
		getItemId: getItemId,
		setItemId: setItemId,
		getContainerId: getContainerId,
		setContainerId: setContainerId,
		getSg: getSg,
		setSg: setSg,
		setHidden: setHidden,
		isHidden: isHidden,
		getManifestAction: getManifestAction,
		setManifestAction: setManifestAction,
		subtractValueQty: subtractValueQty,
		getItemGroupId: getItemGroupId,
		setItemGroupId: setItemGroupId,
		init: init,
		parse: parse,
		toJson: toJson

	}
});

